import { render, staticRenderFns } from "./question.vue?vue&type=template&id=d614381e&scoped=true&"
import script from "./question.vue?vue&type=script&lang=js&"
export * from "./question.vue?vue&type=script&lang=js&"
import style0 from "./question.vue?vue&type=style&index=0&id=d614381e&prod&lang=less&scoped=true&"
import style1 from "./question.vue?vue&type=style&index=1&id=d614381e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d614381e",
  null
  
)

export default component.exports